// Global Shopify theme JavaScript
(function() {
  // Basic Shopify functionality
  console.log('Loopzo theme loaded');
})();